module.exports = __webpack_public_path__ + "fonts/icomoon.fd90b6d9929f37383814b85120216ba1.ttf";